
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/settings",
      function () {
        return require("private-next-pages/user/settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/settings"])
      });
    }
  